import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Button, ErrorSummary } from 'govuk-react-jsx';
import { checkValidEmail, checkValidOzevNumber } from '../../regex/regex';
import { resetPasswordInstaller } from '../../firebase';
import {
  getRegisteredEmailAddress,
  getOzevInstallerNum,
  setRegisteredEmailAddress,
  setOzevInstallerNum,
} from '../../features/installer/installerJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import useTitle from '../../hooks/useTitle';

const RequestLinkForPassword = () => {
  const registeredEmailRedux = useSelector(getRegisteredEmailAddress);
  const ozevInstallerNumberRedux = useSelector(getOzevInstallerNum);
  const [errorMsgEmail, setErrorMsgEmail] = useState(null);
  const [errorInstallerNumber, setErrorInstallerNumber] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'installer.RequestLink.s10',
    'Request a link to access the new service - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const updatedEmailAddress = (event) => {
    dispatch(
      setRegisteredEmailAddress(event.target.value.trim().toLowerCase())
    );
  };

  const updatedOzevInstallerNum = (event) => {
    dispatch(setOzevInstallerNum(event.target.value));
  };

  const errorBlankEmailAddress = copyProvider.getCopy(
    'installer.RequestLink.s6',
    'Enter an email address'
  );

  const errorValidMessage = copyProvider.getCopy(
    'installer.RequestLink.s7',
    'Enter a valid email address'
  );

  const errorBlankOzevNum = copyProvider.getCopy(
    'installer.RequestLink.s8',
    'Enter an OZEV Installer number'
  );

  const errorValidOzevNum = copyProvider.getCopy(
    'installer.RequestLink.s9',
    'Enter a valid OZEV Installer number'
  );

  const handleBtnClick = () => {
    let showErrorEmail;
    let showErrorOzev;
    let hasError = false;
    const errorListArr = [];
    // different conditions for When we have at least one input empty.
    if (ozevInstallerNumberRedux === '' && registeredEmailRedux === '') {
      showErrorEmail = {
        children: errorBlankEmailAddress,
      };
      showErrorOzev = {
        children: errorBlankOzevNum,
      };
      setErrorMsgEmail(showErrorEmail);
      setErrorInstallerNumber(showErrorOzev);
      errorListArr.push(
        { ...showErrorEmail, href: '#input-with-error-message-enter-email' },
        { ...showErrorOzev, href: '#input-with-error-message-ozev-number' }
      );
      hasError = true;
    } else if (
      registeredEmailRedux === '' &&
      checkValidOzevNumber.test(ozevInstallerNumberRedux)
    ) {
      showErrorEmail = {
        children: errorBlankEmailAddress,
      };
      setErrorMsgEmail(showErrorEmail);
      setErrorInstallerNumber(null);
      errorListArr.push({
        ...showErrorEmail,
        href: '#input-with-error-message-enter-email',
      });
      hasError = true;
    } else if (
      ozevInstallerNumberRedux === '' &&
      checkValidEmail.test(registeredEmailRedux)
    ) {
      showErrorOzev = {
        children: errorBlankOzevNum,
      };
      setErrorMsgEmail(null);
      setErrorInstallerNumber(showErrorOzev);
      errorListArr.push({
        ...showErrorOzev,
        href: '#input-with-error-message-ozev-number',
      });
      hasError = true;
    } else if (
      registeredEmailRedux === '' &&
      !checkValidOzevNumber.test(ozevInstallerNumberRedux)
    ) {
      showErrorEmail = {
        children: errorBlankEmailAddress,
      };

      showErrorOzev = {
        children: errorValidOzevNum,
      };
      setErrorMsgEmail(showErrorEmail);
      setErrorInstallerNumber(showErrorOzev);
      errorListArr.push(
        { ...showErrorEmail, href: '#input-with-error-message-enter-email' },
        { ...showErrorOzev, href: '#input-with-error-message-ozev-number' }
      );
      hasError = true;
    } else if (
      ozevInstallerNumberRedux === '' &&
      !checkValidEmail.test(registeredEmailRedux)
    ) {
      showErrorOzev = {
        children: errorBlankOzevNum,
      };
      showErrorEmail = {
        children: errorValidMessage,
      };

      setErrorMsgEmail(showErrorEmail);
      setErrorInstallerNumber(showErrorOzev);
      errorListArr.push(
        { ...showErrorEmail, href: '#input-with-error-message-enter-email' },
        { ...showErrorOzev, href: '#input-with-error-message-ozev-number' }
      );
      hasError = true;
    }
    // different conditions for invalid inputs
    else if (
      !checkValidEmail.test(registeredEmailRedux) &&
      !checkValidOzevNumber.test(ozevInstallerNumberRedux)
    ) {
      showErrorEmail = {
        children: errorValidMessage,
      };
      showErrorOzev = {
        children: errorValidOzevNum,
      };
      setErrorMsgEmail(showErrorEmail);
      setErrorInstallerNumber(showErrorOzev);
      errorListArr.push(
        { ...showErrorEmail, href: '#input-with-error-message-enter-email' },
        { ...showErrorOzev, href: '#input-with-error-message-ozev-number' }
      );
      hasError = true;
    } else if (
      !checkValidOzevNumber.test(ozevInstallerNumberRedux) &&
      checkValidEmail.test(registeredEmailRedux)
    ) {
      showErrorOzev = {
        children: errorValidOzevNum,
      };
      setErrorMsgEmail(null);
      setErrorInstallerNumber(showErrorOzev);
      errorListArr.push({
        ...showErrorOzev,
        href: '#input-with-error-message-ozev-number',
      });
      hasError = true;
    } else if (
      !checkValidEmail.test(registeredEmailRedux) &&
      checkValidOzevNumber.test(ozevInstallerNumberRedux)
    ) {
      showErrorEmail = {
        children: errorValidMessage,
      };
      setErrorMsgEmail(showErrorEmail);
      setErrorInstallerNumber(null);
      errorListArr.push({
        ...showErrorEmail,
        href: '#input-with-error-message-enter-email',
      });
      hasError = true;
    }
    // when we do not have error
    if (!hasError) {
      resetPasswordInstaller({
        email: registeredEmailRedux,
        installer_number: Number(ozevInstallerNumberRedux),
      })
        .then(() => {
          setErrorMsgEmail(null);
          setErrorInstallerNumber(null);
          dispatch(setRegisteredEmailAddress(registeredEmailRedux));
          dispatch(setOzevInstallerNum(ozevInstallerNumberRedux));
          history.push('/installer/link-requested-confirmation');
        })
        .catch((error) => {
          if (error.code === 'functions/invalid-argument') {
            history.push('/landlordApp/unable-to-proceed');
          }
        });
    } else {
      setErrorList(errorListArr);
    }
  };
  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'installer.RequestLink.s1',
          'Request a link to access the new service'
        )}
      </h1>
      <div className="govuk-form-group">
        <Input
          errorMessage={errorMsgEmail}
          id="input-with-error-message-enter-email"
          label={{
            children: copyProvider.getCopy(
              'installer.RequestLink.s2',
              'Current registered email'
            ),
          }}
          hint={{
            children: copyProvider.getCopy(
              'installer.RequestLink.s3',
              'This is the correspondence email address you have provided to OZEV to contact you'
            ),
          }}
          className="govuk-input govuk-!-width-two-thirds"
          name="email-address"
          type="text"
          value={registeredEmailRedux}
          onChange={(event) => updatedEmailAddress(event)}
        />
        <Input
          errorMessage={errorInstallerNumber}
          id="input-with-error-message-ozev-number"
          label={{
            children: copyProvider.getCopy(
              'installer.RequestLink.s4',
              'Your OZEV installer number'
            ),
          }}
          className="govuk-input govuk-!-width-two-thirds"
          name="ozev-installer"
          type="text"
          value={ozevInstallerNumberRedux}
          onChange={(event) => updatedOzevInstallerNum(event)}
        />
      </div>
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy('installer.RequestLink.s5', 'Request link')}
      </Button>
    </>
  );

  return pageModel;
};

export default RequestLinkForPassword;
